module.exports = __webpack_public_path__ + "static/photosbox-5148d34d8f091c892501783e5a2bb91d.webp";